<template>
  <div class="ele-body">
    <el-card class="box-card" shadow="never">
      <el-row :gutter="15">
        <el-col :sm="12">
          <div class="cell"> 上午到校开始时间：{{ schoolTime.amArriveBegin == null ? '未设置' : schoolTime.amArriveBegin }} </div>
          <div class="cell"> 上午放学开始时间：{{ schoolTime.amLeaveBegin }} </div>
          <div class="cell"> 下午到校开始时间：{{ schoolTime.pmArriveBegin }} </div>
          <div class="cell"> 下午放学开始时间：{{ schoolTime.pmLeaveBegin }} </div>
          <div class="cell"> 晚自习到校开始时间：{{ schoolTime.nightArriveBegin }} </div>
          <div class="cell"> 晚自习放学开始时间：{{ schoolTime.nightLeaveBegin }} </div>
        </el-col>
        <el-col :sm="12">
          <div class="cell">上午到校结束时间：{{ schoolTime.amArriveEnd }}</div>
          <div class="cell">上午放学结束时间：{{ schoolTime.amLeaveEnd }}</div>
          <div class="cell">下午到校结束时间：{{ schoolTime.pmArriveEnd }}</div>
          <div class="cell">下午放学结束时间：{{ schoolTime.pmLeaveEnd }}</div>
          <div class="cell"> 晚自习到校结束时间：{{ schoolTime.nightArriveEnd }} </div>
          <div class="cell"> 晚自习放学结束时间：{{ schoolTime.nightLeaveEnd }} </div>
        </el-col>
      </el-row>
      <el-button type="primary" @click="showEdit = true" style="margin-top: 30px">设置时间</el-button>
    </el-card>
    <!-- 设置时间弹窗 -->
    <el-dialog title="设置时间" :visible.sync="showEdit" width="800px" :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
      <el-form :model="schoolTime" ref="schoolTime" label-width="145px">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="上午到校开始时间:" prop="amArriveBegin">
              <el-time-picker v-model="schoolTime.amArriveBegin" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="上午放学开始时间:" prop="amLeaveBegin">
              <el-time-picker v-model="schoolTime.amLeaveBegin" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="下午到校开始时间:" prop="pmArriveBegin">
              <el-time-picker v-model="schoolTime.pmArriveBegin" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="下午放学开始时间:" prop="pmLeaveBegin">
              <el-time-picker v-model="schoolTime.pmLeaveBegin" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="晚自习到校开始时间:" prop="nightArriveBegin">
              <el-time-picker v-model="schoolTime.nightArriveBegin" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="晚自习放学开始时间:" prop="nightLeaveBegin">
              <el-time-picker v-model="schoolTime.nightLeaveBegin" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="上午到校结束时间:" prop="amArriveEnd">
              <el-time-picker v-model="schoolTime.amArriveEnd" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="上午放学结束时间:" prop="amLeaveEnd">
              <el-time-picker v-model="schoolTime.amLeaveEnd" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="下午到校结束时间:" prop="pmArriveEnd">
              <el-time-picker v-model="schoolTime.pmArriveEnd" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="下午放学结束时间:" prop="pmLeaveEnd">
              <el-time-picker v-model="schoolTime.pmLeaveEnd" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="晚自习到校结束时间:" prop="nightArriveEnd">
              <el-time-picker v-model="schoolTime.nightArriveEnd" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
            <el-form-item label="晚自习放学结束时间:" prop="nightLeaveEnd">
              <el-time-picker v-model="schoolTime.nightLeaveEnd" placeholder="请选择时间" value-format="HH:mm" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { findSchoolArriveLeaveTime, setSchoolArriveLeaveTime } from '@/config/api';

  export default {
    name: 'SetSchoolTime',
    data() {
      return {
        showEdit: false,
        schoolTime: {
          amArriveBegin: '',
          amArriveEnd: '',
          amLeaveBegin: '',
          amLeaveEnd: '',
          nightArriveBegin: '',
          nightArriveEnd: '',
          nightLeaveBegin: '',
          nightLeaveEnd: '',
          pmArriveBegin: '',
          pmArriveEnd: '',
          pmLeaveBegin: '',
          pmLeaveEnd: '',
        },
      };
    },
    mounted() {
      this.getSchoolTime();
    },
    methods: {
      getSchoolTime() {
        findSchoolArriveLeaveTime().then((res) => {
          if (res.data.resCode == 200) {
            this.schoolTime = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 保存设置的时间
      save() {
        const loading = this.$loading({ lock: true });
        let data = new FormData();
        for (let key in this.schoolTime) {
          if (this.schoolTime[key] !== null && this.schoolTime[key] !== undefined) {
            data.append(key, this.schoolTime[key]);
          }
        }
        setSchoolArriveLeaveTime(data).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.showEdit = false;
            this.$message({ type: 'success', message: '设置成功' });
            this.getSchoolTime();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .cell {
    line-height: 50px;
  }
</style>
